/* custom (Second Edition), owner 2026-09-25: Similar Products scans the whole catalog, not only the first
   page. sections/product-recommendations.liquid renders one page of 250 products with each match marked
   data-se-pass (1 same type and pre-order status, 2 same type, 3 same furniture group). This script fetches
   every other page through the section rendering API, merges the matches, keeps pass order and trims to the
   section's product limit. product-recommendations.js later swaps the section's inner HTML, so the merge
   runs again whenever the grid is replaced. */
(() => {
  'use strict';
  if (window.seSimilarProducts) return;
  window.seSimilarProducts = true;

  const cache = new Map();

  function slidesFrom(root) {
    return Array.from(root.querySelectorAll('[data-se-similar] > [data-se-pass]'));
  }

  function fetchPage(url, page) {
    const key = url + '|' + page;
    if (!cache.has(key)) {
      const sep = url.indexOf('?') === -1 ? '?' : '&';
      cache.set(key, fetch(url + sep + 'page=' + page, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          return slidesFrom(html);
        })
        .catch(() => []));
    }
    return cache.get(key);
  }

  async function merge(grid) {
    if (grid.dataset.seMerged === 'true' || grid.dataset.seMerging === 'true') return;
    grid.dataset.seMerging = 'true';
    const limit = Number(grid.dataset.seLimit) || 6;
    const pages = Number(grid.dataset.sePages) || 1;
    let slides = slidesFrom(grid.parentElement || grid);
    if (pages > 1 && grid.dataset.seUrl) {
      const others = await Promise.all(Array.from({ length: pages - 1 }, (_, i) => fetchPage(grid.dataset.seUrl, i + 2)));
      others.forEach((list) => { slides = slides.concat(list); });
    }
    const seen = new Set();
    const best = slides
      .map((slide, index) => ({ slide, index, pass: Number(slide.dataset.sePass) || 9 }))
      .sort((a, b) => a.pass - b.pass || a.index - b.index)
      .filter(({ slide }) => {
        const handle = slide.dataset.seHandle;
        if (!handle || seen.has(handle)) return false;
        seen.add(handle);
        return true;
      })
      .slice(0, limit)
      .map(({ slide }) => slide);
    grid.replaceChildren(...best);
    grid.dataset.seMerged = 'true';
    delete grid.dataset.seMerging;
    const section = grid.closest('product-recommendations');
    if (section && !best.length) section.hidden = true;
    grid.querySelectorAll('.lazyload').forEach((image) => {
      if (window.lazySizes) window.lazySizes.loader.unveil(image);
    });
  }

  function run() {
    document.querySelectorAll('[data-se-similar]').forEach((grid) => { merge(grid); });
  }

  function init() {
    run();
    document.querySelectorAll('product-recommendations').forEach((element) => {
      new MutationObserver(run).observe(element, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
